import DOMPurify from 'dompurify';

export const whatsAppParser = (rawMessage: string): string => {
  if (!rawMessage) return '';

  // SEGURANCA: evita que injetem código malicioso no dom
  let message = DOMPurify.sanitize(rawMessage);

  // Flags: 'g' = global, 's' = dotAll (permite que . case novas linhas)
  const boldRegex   = /\*(.+?)\*/gs;
  const italicRegex = /_(.+?)_/gs;
  const strikeRegex = /~(.+?)~/gs;

  message = message.replace(boldRegex, '<strong>$1</strong>');

  message = message.replace(italicRegex, '<span style="font-style: italic;">$1</span>');

  message = message.replace(strikeRegex, '<span style="text-decoration: line-through;">$1</span>');

  message = message.replace(/\n/g, '<br>');

  return message;
};
